var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunicationGoalsLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(-1004.5 -1242.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_427",
    "data-name": "Ellipse 427",
    cx: 58.5,
    cy: 58.5,
    r: 58.5,
    transform: "translate(1004.5 1242.5)",
    fill: "#3a4656"
  }), /*#__PURE__*/React.createElement("g", {
    id: "goal",
    transform: "translate(1033.003 1271.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M1.731,59.1H57.368A1.731,1.731,0,0,0,59.1,57.368V49.829a4.987,4.987,0,0,0-1.091-3.108L49.633,36.268a3.606,3.606,0,0,0-5.6-.034l-3.16,3.848-5.624-8.067c-.02-.029-.041-.057-.063-.085a7.147,7.147,0,0,0-3.9-2.514v-9.31h6.858v3.308a1.731,1.731,0,0,0,1.731,1.731H54.276A1.733,1.733,0,0,0,55.5,22.191l-4.3-4.3L55.8,13.3a1.733,1.733,0,0,0-1.224-2.956H43.464V7.037a1.731,1.731,0,0,0-1.731-1.731H31.281V1.731a1.731,1.731,0,0,0-3.463,0V29.416a7.147,7.147,0,0,0-3.9,2.514q-.033.042-.063.085l-5.623,8.066-3.16-3.848a3.607,3.607,0,0,0-5.6.034L1.091,46.721A4.988,4.988,0,0,0,0,49.829v7.539A1.731,1.731,0,0,0,1.731,59.1ZM41.6,20.107a1.739,1.739,0,0,0,1.862-1.731V13.808h6.929L47.531,16.67a1.732,1.732,0,0,0,0,2.449L50.1,21.684H41.6ZM31.281,8.768H40v7.876h-8.72ZM46.707,38.432a.143.143,0,0,1,.223,0l8.375,10.453a1.512,1.512,0,0,1,.331.942v5.807H51.715l-8.786-12.6ZM26.659,34.043a3.725,3.725,0,0,1,5.781,0L47.493,55.637H42.441l-5.475-8.313a1.731,1.731,0,0,0-2.892,1.9l4.221,6.408H20.8l4.221-6.408a1.731,1.731,0,0,0-2.892-1.9l-5.475,8.313H11.606ZM3.463,49.829a1.514,1.514,0,0,1,.331-.942l8.375-10.453a.143.143,0,0,1,.223,0l3.778,4.6-8.786,12.6H3.463Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationGoalsLarge);
export default __webpack_public_path__ + "static/media/communication-goals-large.d287f420660e2264e61d2d22b5a5d9e8.svg";
export { ForwardRef as ReactComponent };